import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { CreateTicketStatusPage } from "./pages/CreateTicketStatusPage";
import { EditTicketStatusPage } from "./pages/EditTicketStatusPage";
import { TicketStatusListPage } from "./pages/TicketStatusListPage";
import { canListStatuses, canManageStatuses } from "./permissions";
import { ticketStatusesRoutes } from "./routes";

export const ticketStatusesRoute = [
  {
    path: ticketStatusesRoutes.list,
    element: (
      <RequireAuth permission={canListStatuses}>
        <TicketStatusListPage />
      </RequireAuth>
    ),
  },
  {
    path: ticketStatusesRoutes.create,
    element: (
      <RequireAuth permission={canManageStatuses}>
        <CreateTicketStatusPage />
      </RequireAuth>
    ),
  },
  {
    path: ticketStatusesRoutes.edit,
    element: (
      <RequireAuth permission={canManageStatuses}>
        <EditTicketStatusPage />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
